module.exports = __webpack_public_path__ + "img/soporte_globalwork.946f2327.png";